import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PipAppbarModule, PipRootLayoutModule, PipShadowModule } from 'pip-webui2-layouts';
import {
  PipBreadcrumbModule, PipNavHeaderModule, PipNavIconModule, PipNavMenuModule,
  PipNavModule, PipPrimaryActionsModule, PipSecondaryActionsModule
} from 'pip-webui2-nav';
import { GaSidenavModule } from './../../components/sidenav/sidenav.module';
import { GaMainLayoutComponent } from './main-layout.component';

@NgModule({
  declarations: [GaMainLayoutComponent],
  exports: [GaMainLayoutComponent],
  // entryComponents: [GaAskDialogComponent],
  imports: [
    // Angular and vendors
    CommonModule,
    FlexLayoutModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatChipsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatProgressBarModule,
    MatSelectModule,
    MatSnackBarModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,

    // pip-suite2 & pip-webui2
    PipAppbarModule,
    PipBreadcrumbModule,
    PipNavIconModule,
    PipNavModule,
    PipNavHeaderModule,
    PipNavMenuModule,
    PipPrimaryActionsModule,
    PipRootLayoutModule,
    PipShadowModule,
    PipSecondaryActionsModule,

    // ga
    GaSidenavModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class GaMainLayoutModule { }
